import { useReducer } from 'react';
import { reducer } from './reducer';

const INITIAL_STATE = {
	isLoading: true,
	isSignout: false,
	userToken: null,
	mediaToken: null,
	isSignedInCurrentAppRun: false,
};

export const useAuthState = () => {
	return useReducer(reducer, INITIAL_STATE);
};
